// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var Provider;
(function (Provider) {
    Provider["PROVIDER_UNSPECIFIED"] = "PROVIDER_UNSPECIFIED";
    Provider["PROVIDER_BANDWIDTH"] = "PROVIDER_BANDWIDTH";
    Provider["PROVIDER_TELNYX"] = "PROVIDER_TELNYX";
    Provider["PROVIDER_BANDWIDTH_TO_DOCUMO"] = "PROVIDER_BANDWIDTH_TO_DOCUMO";
    Provider["PROVIDER_MOCK"] = "PROVIDER_MOCK";
    Provider["PROVIDER_BANDWIDTH_TO_TELNYX"] = "PROVIDER_BANDWIDTH_TO_TELNYX";
})(Provider || (Provider = {}));
export var Provider_index;
(function (Provider_index) {
    Provider_index[Provider_index["PROVIDER_UNSPECIFIED"] = 0] = "PROVIDER_UNSPECIFIED";
    Provider_index[Provider_index["PROVIDER_BANDWIDTH"] = 1] = "PROVIDER_BANDWIDTH";
    Provider_index[Provider_index["PROVIDER_TELNYX"] = 2] = "PROVIDER_TELNYX";
    Provider_index[Provider_index["PROVIDER_BANDWIDTH_TO_DOCUMO"] = 3] = "PROVIDER_BANDWIDTH_TO_DOCUMO";
    Provider_index[Provider_index["PROVIDER_MOCK"] = 4] = "PROVIDER_MOCK";
    Provider_index[Provider_index["PROVIDER_BANDWIDTH_TO_TELNYX"] = 5] = "PROVIDER_BANDWIDTH_TO_TELNYX";
})(Provider_index || (Provider_index = {}));
export var SMSPortOrderStatus;
(function (SMSPortOrderStatus) {
    SMSPortOrderStatus["SMS_PORT_ORDER_STATUS_UNSPECIFIED"] = "SMS_PORT_ORDER_STATUS_UNSPECIFIED";
    SMSPortOrderStatus["SMS_PORT_ORDER_STATUS_PENDING"] = "SMS_PORT_ORDER_STATUS_PENDING";
    SMSPortOrderStatus["SMS_PORT_ORDER_STATUS_SUCCESSFUL"] = "SMS_PORT_ORDER_STATUS_SUCCESSFUL";
    SMSPortOrderStatus["SMS_PORT_ORDER_STATUS_DELETED"] = "SMS_PORT_ORDER_STATUS_DELETED";
    SMSPortOrderStatus["SMS_PORT_ORDER_STATUS_FAILED"] = "SMS_PORT_ORDER_STATUS_FAILED";
    SMSPortOrderStatus["SMS_PORT_ORDER_STATUS_EXPIRED"] = "SMS_PORT_ORDER_STATUS_EXPIRED";
    SMSPortOrderStatus["SMS_PORT_ORDER_STATUS_RECEIVED"] = "SMS_PORT_ORDER_STATUS_RECEIVED";
    SMSPortOrderStatus["SMS_PORT_ORDER_STATUS_PROCESSING"] = "SMS_PORT_ORDER_STATUS_PROCESSING";
    SMSPortOrderStatus["SMS_PORT_ORDER_STATUS_COMPLETE"] = "SMS_PORT_ORDER_STATUS_COMPLETE";
    SMSPortOrderStatus["SMS_PORT_ORDER_STATUS_PARTIAL"] = "SMS_PORT_ORDER_STATUS_PARTIAL";
    SMSPortOrderStatus["SMS_PORT_ORDER_STATUS_EXCEPTION_ENCOUNTERED"] = "SMS_PORT_ORDER_STATUS_EXCEPTION_ENCOUNTERED";
})(SMSPortOrderStatus || (SMSPortOrderStatus = {}));
export var SMSPortOrderStatus_index;
(function (SMSPortOrderStatus_index) {
    SMSPortOrderStatus_index[SMSPortOrderStatus_index["SMS_PORT_ORDER_STATUS_UNSPECIFIED"] = 0] = "SMS_PORT_ORDER_STATUS_UNSPECIFIED";
    SMSPortOrderStatus_index[SMSPortOrderStatus_index["SMS_PORT_ORDER_STATUS_PENDING"] = 1] = "SMS_PORT_ORDER_STATUS_PENDING";
    SMSPortOrderStatus_index[SMSPortOrderStatus_index["SMS_PORT_ORDER_STATUS_SUCCESSFUL"] = 2] = "SMS_PORT_ORDER_STATUS_SUCCESSFUL";
    SMSPortOrderStatus_index[SMSPortOrderStatus_index["SMS_PORT_ORDER_STATUS_DELETED"] = 3] = "SMS_PORT_ORDER_STATUS_DELETED";
    SMSPortOrderStatus_index[SMSPortOrderStatus_index["SMS_PORT_ORDER_STATUS_FAILED"] = 4] = "SMS_PORT_ORDER_STATUS_FAILED";
    SMSPortOrderStatus_index[SMSPortOrderStatus_index["SMS_PORT_ORDER_STATUS_EXPIRED"] = 5] = "SMS_PORT_ORDER_STATUS_EXPIRED";
    SMSPortOrderStatus_index[SMSPortOrderStatus_index["SMS_PORT_ORDER_STATUS_RECEIVED"] = 6] = "SMS_PORT_ORDER_STATUS_RECEIVED";
    SMSPortOrderStatus_index[SMSPortOrderStatus_index["SMS_PORT_ORDER_STATUS_PROCESSING"] = 7] = "SMS_PORT_ORDER_STATUS_PROCESSING";
    SMSPortOrderStatus_index[SMSPortOrderStatus_index["SMS_PORT_ORDER_STATUS_COMPLETE"] = 8] = "SMS_PORT_ORDER_STATUS_COMPLETE";
    SMSPortOrderStatus_index[SMSPortOrderStatus_index["SMS_PORT_ORDER_STATUS_PARTIAL"] = 9] = "SMS_PORT_ORDER_STATUS_PARTIAL";
    SMSPortOrderStatus_index[SMSPortOrderStatus_index["SMS_PORT_ORDER_STATUS_EXCEPTION_ENCOUNTERED"] = 10] = "SMS_PORT_ORDER_STATUS_EXCEPTION_ENCOUNTERED";
})(SMSPortOrderStatus_index || (SMSPortOrderStatus_index = {}));
export var MediaType;
(function (MediaType) {
    MediaType["MEDIA_TYPE_UNSPECIFIED"] = "MEDIA_TYPE_UNSPECIFIED";
    MediaType["MEDIA_TYPE_PHONE_BILL"] = "MEDIA_TYPE_PHONE_BILL";
    MediaType["MEDIA_TYPE_LOA"] = "MEDIA_TYPE_LOA";
    MediaType["MEDIA_TYPE_CSR"] = "MEDIA_TYPE_CSR";
})(MediaType || (MediaType = {}));
export var MediaType_index;
(function (MediaType_index) {
    MediaType_index[MediaType_index["MEDIA_TYPE_UNSPECIFIED"] = 0] = "MEDIA_TYPE_UNSPECIFIED";
    MediaType_index[MediaType_index["MEDIA_TYPE_PHONE_BILL"] = 1] = "MEDIA_TYPE_PHONE_BILL";
    MediaType_index[MediaType_index["MEDIA_TYPE_LOA"] = 2] = "MEDIA_TYPE_LOA";
    MediaType_index[MediaType_index["MEDIA_TYPE_CSR"] = 3] = "MEDIA_TYPE_CSR";
})(MediaType_index || (MediaType_index = {}));
export var PortType;
(function (PortType) {
    PortType["PORT_TYPE_UNSPECIFIED"] = "PORT_TYPE_UNSPECIFIED";
    PortType["PORT_TYPE_AUTOMATED"] = "PORT_TYPE_AUTOMATED";
    PortType["PORT_TYPE_AUTOMATEDOFFNET"] = "PORT_TYPE_AUTOMATEDOFFNET";
    PortType["PORT_TYPE_INTERNAL"] = "PORT_TYPE_INTERNAL";
    PortType["PORT_TYPE_MANUAL_ON_NET"] = "PORT_TYPE_MANUAL_ON_NET";
    PortType["PORT_TYPE_MANUALOFFNET"] = "PORT_TYPE_MANUALOFFNET";
    PortType["PORT_TYPE_MANUAL_TOLLFREE"] = "PORT_TYPE_MANUAL_TOLLFREE";
    PortType["PORT_TYPE_MIXED"] = "PORT_TYPE_MIXED";
})(PortType || (PortType = {}));
export var PortType_index;
(function (PortType_index) {
    PortType_index[PortType_index["PORT_TYPE_UNSPECIFIED"] = 0] = "PORT_TYPE_UNSPECIFIED";
    PortType_index[PortType_index["PORT_TYPE_AUTOMATED"] = 1] = "PORT_TYPE_AUTOMATED";
    PortType_index[PortType_index["PORT_TYPE_AUTOMATEDOFFNET"] = 2] = "PORT_TYPE_AUTOMATEDOFFNET";
    PortType_index[PortType_index["PORT_TYPE_INTERNAL"] = 3] = "PORT_TYPE_INTERNAL";
    PortType_index[PortType_index["PORT_TYPE_MANUAL_ON_NET"] = 4] = "PORT_TYPE_MANUAL_ON_NET";
    PortType_index[PortType_index["PORT_TYPE_MANUALOFFNET"] = 5] = "PORT_TYPE_MANUALOFFNET";
    PortType_index[PortType_index["PORT_TYPE_MANUAL_TOLLFREE"] = 6] = "PORT_TYPE_MANUAL_TOLLFREE";
    PortType_index[PortType_index["PORT_TYPE_MIXED"] = 7] = "PORT_TYPE_MIXED";
})(PortType_index || (PortType_index = {}));
export var NumberType;
(function (NumberType) {
    NumberType["NUMBER_TYPE_UNSPECIFIED"] = "NUMBER_TYPE_UNSPECIFIED";
    NumberType["NUMBER_TYPE_FAX"] = "NUMBER_TYPE_FAX";
    NumberType["NUMBER_TYPE_SMS"] = "NUMBER_TYPE_SMS";
    NumberType["NUMBER_TYPE_PHONE"] = "NUMBER_TYPE_PHONE";
})(NumberType || (NumberType = {}));
export var NumberType_index;
(function (NumberType_index) {
    NumberType_index[NumberType_index["NUMBER_TYPE_UNSPECIFIED"] = 0] = "NUMBER_TYPE_UNSPECIFIED";
    NumberType_index[NumberType_index["NUMBER_TYPE_FAX"] = 1] = "NUMBER_TYPE_FAX";
    NumberType_index[NumberType_index["NUMBER_TYPE_SMS"] = 2] = "NUMBER_TYPE_SMS";
    NumberType_index[NumberType_index["NUMBER_TYPE_PHONE"] = 3] = "NUMBER_TYPE_PHONE";
})(NumberType_index || (NumberType_index = {}));
export var PortStatus;
(function (PortStatus) {
    PortStatus["PORT_STATUS_UNSPECIFIED"] = "PORT_STATUS_UNSPECIFIED";
    PortStatus["PORT_STATUS_DRAFT"] = "PORT_STATUS_DRAFT";
    PortStatus["PORT_STATUS_PENDING"] = "PORT_STATUS_PENDING";
    PortStatus["PORT_STATUS_SUBMITTED"] = "PORT_STATUS_SUBMITTED";
    PortStatus["PORT_STATUS_REJECTED"] = "PORT_STATUS_REJECTED";
    PortStatus["PORT_STATUS_REJECTION_RESOLVED"] = "PORT_STATUS_REJECTION_RESOLVED";
    PortStatus["PORT_STATUS_RESUBMITTED"] = "PORT_STATUS_RESUBMITTED";
    PortStatus["PORT_STATUS_SUP_PENDING"] = "PORT_STATUS_SUP_PENDING";
    PortStatus["PORT_STATUS_SUP_SUBMITTED"] = "PORT_STATUS_SUP_SUBMITTED";
    PortStatus["PORT_STATUS_CANCEL_PENDING"] = "PORT_STATUS_CANCEL_PENDING";
    PortStatus["PORT_STATUS_CANCEL_SUBMITTED"] = "PORT_STATUS_CANCEL_SUBMITTED";
    PortStatus["PORT_STATUS_CANCELLED"] = "PORT_STATUS_CANCELLED";
    PortStatus["PORT_STATUS_ACCEPTED"] = "PORT_STATUS_ACCEPTED";
    PortStatus["PORT_STATUS_COMPLETED"] = "PORT_STATUS_COMPLETED";
    PortStatus["PORT_STATUS_PENDING_DOCUMENTS"] = "PORT_STATUS_PENDING_DOCUMENTS";
    PortStatus["PORT_STATUS_EXCEPTION"] = "PORT_STATUS_EXCEPTION";
    PortStatus["PORT_STATUS_REQUESTED_SUPP"] = "PORT_STATUS_REQUESTED_SUPP";
    PortStatus["PORT_STATUS_REQUESTED_CANCEL"] = "PORT_STATUS_REQUESTED_CANCEL";
    PortStatus["PORT_STATUS_FOC"] = "PORT_STATUS_FOC";
    PortStatus["PORT_STATUS_SPLIT_PORT"] = "PORT_STATUS_SPLIT_PORT";
    PortStatus["PORT_STATUS_ARCHIVED"] = "PORT_STATUS_ARCHIVED";
    PortStatus["PORT_STATUS_DELETED"] = "PORT_STATUS_DELETED";
    PortStatus["PORT_STATUS_ACTIVATION_IN_PROGRESS"] = "PORT_STATUS_ACTIVATION_IN_PROGRESS";
    PortStatus["PORT_STATUS_VALIDATION_FAILED"] = "PORT_STATUS_VALIDATION_FAILED";
    PortStatus["PORT_STATUS_VALIDATE_TFNS"] = "PORT_STATUS_VALIDATE_TFNS";
    PortStatus["PORT_STATUS_INVALID_TFNS"] = "PORT_STATUS_INVALID_TFNS";
    PortStatus["PORT_STATUS_DRAFT_INCOMPLETE"] = "PORT_STATUS_DRAFT_INCOMPLETE";
})(PortStatus || (PortStatus = {}));
export var PortStatus_index;
(function (PortStatus_index) {
    PortStatus_index[PortStatus_index["PORT_STATUS_UNSPECIFIED"] = 0] = "PORT_STATUS_UNSPECIFIED";
    PortStatus_index[PortStatus_index["PORT_STATUS_DRAFT"] = 1] = "PORT_STATUS_DRAFT";
    PortStatus_index[PortStatus_index["PORT_STATUS_PENDING"] = 2] = "PORT_STATUS_PENDING";
    PortStatus_index[PortStatus_index["PORT_STATUS_SUBMITTED"] = 3] = "PORT_STATUS_SUBMITTED";
    PortStatus_index[PortStatus_index["PORT_STATUS_REJECTED"] = 4] = "PORT_STATUS_REJECTED";
    PortStatus_index[PortStatus_index["PORT_STATUS_REJECTION_RESOLVED"] = 5] = "PORT_STATUS_REJECTION_RESOLVED";
    PortStatus_index[PortStatus_index["PORT_STATUS_RESUBMITTED"] = 6] = "PORT_STATUS_RESUBMITTED";
    PortStatus_index[PortStatus_index["PORT_STATUS_SUP_PENDING"] = 7] = "PORT_STATUS_SUP_PENDING";
    PortStatus_index[PortStatus_index["PORT_STATUS_SUP_SUBMITTED"] = 8] = "PORT_STATUS_SUP_SUBMITTED";
    PortStatus_index[PortStatus_index["PORT_STATUS_CANCEL_PENDING"] = 9] = "PORT_STATUS_CANCEL_PENDING";
    PortStatus_index[PortStatus_index["PORT_STATUS_CANCEL_SUBMITTED"] = 10] = "PORT_STATUS_CANCEL_SUBMITTED";
    PortStatus_index[PortStatus_index["PORT_STATUS_CANCELLED"] = 11] = "PORT_STATUS_CANCELLED";
    PortStatus_index[PortStatus_index["PORT_STATUS_ACCEPTED"] = 12] = "PORT_STATUS_ACCEPTED";
    PortStatus_index[PortStatus_index["PORT_STATUS_COMPLETED"] = 13] = "PORT_STATUS_COMPLETED";
    PortStatus_index[PortStatus_index["PORT_STATUS_PENDING_DOCUMENTS"] = 14] = "PORT_STATUS_PENDING_DOCUMENTS";
    PortStatus_index[PortStatus_index["PORT_STATUS_EXCEPTION"] = 15] = "PORT_STATUS_EXCEPTION";
    PortStatus_index[PortStatus_index["PORT_STATUS_REQUESTED_SUPP"] = 16] = "PORT_STATUS_REQUESTED_SUPP";
    PortStatus_index[PortStatus_index["PORT_STATUS_REQUESTED_CANCEL"] = 17] = "PORT_STATUS_REQUESTED_CANCEL";
    PortStatus_index[PortStatus_index["PORT_STATUS_FOC"] = 18] = "PORT_STATUS_FOC";
    PortStatus_index[PortStatus_index["PORT_STATUS_SPLIT_PORT"] = 19] = "PORT_STATUS_SPLIT_PORT";
    PortStatus_index[PortStatus_index["PORT_STATUS_ARCHIVED"] = 20] = "PORT_STATUS_ARCHIVED";
    PortStatus_index[PortStatus_index["PORT_STATUS_DELETED"] = 21] = "PORT_STATUS_DELETED";
    PortStatus_index[PortStatus_index["PORT_STATUS_ACTIVATION_IN_PROGRESS"] = 22] = "PORT_STATUS_ACTIVATION_IN_PROGRESS";
    PortStatus_index[PortStatus_index["PORT_STATUS_VALIDATION_FAILED"] = 23] = "PORT_STATUS_VALIDATION_FAILED";
    PortStatus_index[PortStatus_index["PORT_STATUS_VALIDATE_TFNS"] = 24] = "PORT_STATUS_VALIDATE_TFNS";
    PortStatus_index[PortStatus_index["PORT_STATUS_INVALID_TFNS"] = 25] = "PORT_STATUS_INVALID_TFNS";
    PortStatus_index[PortStatus_index["PORT_STATUS_DRAFT_INCOMPLETE"] = 26] = "PORT_STATUS_DRAFT_INCOMPLETE";
})(PortStatus_index || (PortStatus_index = {}));
export var CurrentAccountType;
(function (CurrentAccountType) {
    CurrentAccountType["CURRENT_ACCOUNT_TYPE_UNSPECIFIED"] = "CURRENT_ACCOUNT_TYPE_UNSPECIFIED";
    CurrentAccountType["CURRENT_ACCOUNT_TYPE_BUSINESS"] = "CURRENT_ACCOUNT_TYPE_BUSINESS";
    CurrentAccountType["CURRENT_ACCOUNT_TYPE_RESIDENTIAL"] = "CURRENT_ACCOUNT_TYPE_RESIDENTIAL";
})(CurrentAccountType || (CurrentAccountType = {}));
export var CurrentAccountType_index;
(function (CurrentAccountType_index) {
    CurrentAccountType_index[CurrentAccountType_index["CURRENT_ACCOUNT_TYPE_UNSPECIFIED"] = 0] = "CURRENT_ACCOUNT_TYPE_UNSPECIFIED";
    CurrentAccountType_index[CurrentAccountType_index["CURRENT_ACCOUNT_TYPE_BUSINESS"] = 1] = "CURRENT_ACCOUNT_TYPE_BUSINESS";
    CurrentAccountType_index[CurrentAccountType_index["CURRENT_ACCOUNT_TYPE_RESIDENTIAL"] = 2] = "CURRENT_ACCOUNT_TYPE_RESIDENTIAL";
})(CurrentAccountType_index || (CurrentAccountType_index = {}));
// the values are a direct mapping to Bandwidth's API.  We kept the inconsistency to conform to their format.
export var LNPPortType;
(function (LNPPortType) {
    LNPPortType["LNP_PORT_TYPE_UNSPECIFIED"] = "LNP_PORT_TYPE_UNSPECIFIED";
    LNPPortType["LNP_PORT_TYPE_AUTOMATED"] = "LNP_PORT_TYPE_AUTOMATED";
    LNPPortType["LNP_PORT_TYPE_AUTOMATEDOFFNET"] = "LNP_PORT_TYPE_AUTOMATEDOFFNET";
    LNPPortType["LNP_PORT_TYPE_INTERNAL"] = "LNP_PORT_TYPE_INTERNAL";
    LNPPortType["LNP_PORT_TYPE_MANUAL_ON_NET"] = "LNP_PORT_TYPE_MANUAL_ON_NET";
    LNPPortType["LNP_PORT_TYPE_MANUALOFFNET"] = "LNP_PORT_TYPE_MANUALOFFNET";
    LNPPortType["LNP_PORT_TYPE_MANUAL_TOLLFREE"] = "LNP_PORT_TYPE_MANUAL_TOLLFREE";
    LNPPortType["LNP_PORT_TYPE_MIXED"] = "LNP_PORT_TYPE_MIXED";
})(LNPPortType || (LNPPortType = {}));
export var LNPPortType_index;
(function (LNPPortType_index) {
    LNPPortType_index[LNPPortType_index["LNP_PORT_TYPE_UNSPECIFIED"] = 0] = "LNP_PORT_TYPE_UNSPECIFIED";
    LNPPortType_index[LNPPortType_index["LNP_PORT_TYPE_AUTOMATED"] = 1] = "LNP_PORT_TYPE_AUTOMATED";
    LNPPortType_index[LNPPortType_index["LNP_PORT_TYPE_AUTOMATEDOFFNET"] = 2] = "LNP_PORT_TYPE_AUTOMATEDOFFNET";
    LNPPortType_index[LNPPortType_index["LNP_PORT_TYPE_INTERNAL"] = 3] = "LNP_PORT_TYPE_INTERNAL";
    LNPPortType_index[LNPPortType_index["LNP_PORT_TYPE_MANUAL_ON_NET"] = 4] = "LNP_PORT_TYPE_MANUAL_ON_NET";
    LNPPortType_index[LNPPortType_index["LNP_PORT_TYPE_MANUALOFFNET"] = 5] = "LNP_PORT_TYPE_MANUALOFFNET";
    LNPPortType_index[LNPPortType_index["LNP_PORT_TYPE_MANUAL_TOLLFREE"] = 6] = "LNP_PORT_TYPE_MANUAL_TOLLFREE";
    LNPPortType_index[LNPPortType_index["LNP_PORT_TYPE_MIXED"] = 7] = "LNP_PORT_TYPE_MIXED";
})(LNPPortType_index || (LNPPortType_index = {}));
export var RequestClient;
(function (RequestClient) {
    RequestClient["REQUEST_CLIENT_UNSPECIFIED"] = "REQUEST_CLIENT_UNSPECIFIED";
    RequestClient["REQUEST_CLIENT_MOBILE"] = "REQUEST_CLIENT_MOBILE";
    RequestClient["REQUEST_CLIENT_DESKTOP"] = "REQUEST_CLIENT_DESKTOP";
    RequestClient["REQUEST_CLIENT_WAM"] = "REQUEST_CLIENT_WAM";
    RequestClient["REQUEST_CLIENT_ADMIN_PORTAL"] = "REQUEST_CLIENT_ADMIN_PORTAL";
    RequestClient["REQUEST_CLIENT_DASHBOARD"] = "REQUEST_CLIENT_DASHBOARD";
    RequestClient["REQUEST_CLIENT_INTAKE_FORM"] = "REQUEST_CLIENT_INTAKE_FORM";
})(RequestClient || (RequestClient = {}));
export var RequestClient_index;
(function (RequestClient_index) {
    RequestClient_index[RequestClient_index["REQUEST_CLIENT_UNSPECIFIED"] = 0] = "REQUEST_CLIENT_UNSPECIFIED";
    RequestClient_index[RequestClient_index["REQUEST_CLIENT_MOBILE"] = 1] = "REQUEST_CLIENT_MOBILE";
    RequestClient_index[RequestClient_index["REQUEST_CLIENT_DESKTOP"] = 2] = "REQUEST_CLIENT_DESKTOP";
    RequestClient_index[RequestClient_index["REQUEST_CLIENT_WAM"] = 3] = "REQUEST_CLIENT_WAM";
    RequestClient_index[RequestClient_index["REQUEST_CLIENT_ADMIN_PORTAL"] = 4] = "REQUEST_CLIENT_ADMIN_PORTAL";
    RequestClient_index[RequestClient_index["REQUEST_CLIENT_DASHBOARD"] = 5] = "REQUEST_CLIENT_DASHBOARD";
    RequestClient_index[RequestClient_index["REQUEST_CLIENT_INTAKE_FORM"] = 6] = "REQUEST_CLIENT_INTAKE_FORM";
})(RequestClient_index || (RequestClient_index = {}));
export var PortingType;
(function (PortingType) {
    PortingType["PORTING_TYPE_UNKNOWN"] = "PORTING_TYPE_UNKNOWN";
    PortingType["PORTING_TYPE_INTERNAL"] = "PORTING_TYPE_INTERNAL";
    PortingType["PORTING_TYPE_MAIN"] = "PORTING_TYPE_MAIN";
})(PortingType || (PortingType = {}));
export var PortingType_index;
(function (PortingType_index) {
    PortingType_index[PortingType_index["PORTING_TYPE_UNKNOWN"] = 0] = "PORTING_TYPE_UNKNOWN";
    PortingType_index[PortingType_index["PORTING_TYPE_INTERNAL"] = 1] = "PORTING_TYPE_INTERNAL";
    PortingType_index[PortingType_index["PORTING_TYPE_MAIN"] = 2] = "PORTING_TYPE_MAIN";
})(PortingType_index || (PortingType_index = {}));
// from monorail/shared/protorepo/enums/insys/porting/salesforce.proto
export var PortGeneration;
(function (PortGeneration) {
    PortGeneration["PORT_GENERATION_UNKNOWN"] = "PORT_GENERATION_UNKNOWN";
    PortGeneration["PORT_GENERATION_DESKTOP"] = "PORT_GENERATION_DESKTOP";
    PortGeneration["PORT_GENERATION_MOBILE"] = "PORT_GENERATION_MOBILE";
    PortGeneration["PORT_GENERATION_WAM"] = "PORT_GENERATION_WAM";
    PortGeneration["PORT_GENERATION_ADMIN_PORTAL"] = "PORT_GENERATION_ADMIN_PORTAL";
    PortGeneration["PORT_GENERATION_INTAKE_FORM"] = "PORT_GENERATION_INTAKE_FORM";
})(PortGeneration || (PortGeneration = {}));
export var PortGeneration_index;
(function (PortGeneration_index) {
    PortGeneration_index[PortGeneration_index["PORT_GENERATION_UNKNOWN"] = 0] = "PORT_GENERATION_UNKNOWN";
    PortGeneration_index[PortGeneration_index["PORT_GENERATION_DESKTOP"] = 1] = "PORT_GENERATION_DESKTOP";
    PortGeneration_index[PortGeneration_index["PORT_GENERATION_MOBILE"] = 2] = "PORT_GENERATION_MOBILE";
    PortGeneration_index[PortGeneration_index["PORT_GENERATION_WAM"] = 3] = "PORT_GENERATION_WAM";
    PortGeneration_index[PortGeneration_index["PORT_GENERATION_ADMIN_PORTAL"] = 4] = "PORT_GENERATION_ADMIN_PORTAL";
    PortGeneration_index[PortGeneration_index["PORT_GENERATION_INTAKE_FORM"] = 5] = "PORT_GENERATION_INTAKE_FORM";
})(PortGeneration_index || (PortGeneration_index = {}));
